define('modules/editor/behaviours/apply_content',['require','exports','module'],function(require, exports, module) {
  "use strict";

  module.exports = {
    applyStyles: function($el) {
      $el.html(this.get("content"));
    }
  };

});

